import React, { useState, useEffect } from 'react';
import { storage, firestore } from './firebaseConfig';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const MagazineInput = () => {
  const [magazineName, setMagazineName] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [magazines, setMagazines] = useState([]);
  const [selectedMagazineId, setSelectedMagazineId] = useState(null);
  const [existingImageUrl, setExistingImageUrl] = useState('');
  const [existingPdfUrl, setExistingPdfUrl] = useState('');

  useEffect(() => {
    const fetchMagazines = async () => {
      const magazinesCollection = collection(firestore, 'magazines');
      const magazinesSnapshot = await getDocs(magazinesCollection);
      setMagazines(magazinesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchMagazines();
  }, []);

  const handleAddOrUpdateMagazine = async () => {
    if (magazineName && (imageFile || existingImageUrl) && (pdfFile || existingPdfUrl)) {
      try {
        let imageUrl = existingImageUrl;
        let pdfUrl = existingPdfUrl;

        if (imageFile) {
          const imageRef = ref(storage, `magazines/images/${imageFile.name}`);
          const imageUploadTask = uploadBytesResumable(imageRef, imageFile);
          const imageSnapshot = await new Promise((resolve, reject) => {
            imageUploadTask.on('state_changed', null, reject, () => resolve(imageUploadTask.snapshot));
          });
          imageUrl = await getDownloadURL(imageSnapshot.ref);
        }

        if (pdfFile) {
          const pdfRef = ref(storage, `magazines/pdfs/${pdfFile.name}`);
          const pdfUploadTask = uploadBytesResumable(pdfRef, pdfFile);
          const pdfSnapshot = await new Promise((resolve, reject) => {
            pdfUploadTask.on('state_changed', null, reject, () => resolve(pdfUploadTask.snapshot));
          });
          pdfUrl = await getDownloadURL(pdfSnapshot.ref);
        }

        if (selectedMagazineId) {
          const magazineDoc = doc(firestore, 'magazines', selectedMagazineId);
          await updateDoc(magazineDoc, {
            name: magazineName,
            imageUrl,
            pdfUrl,
          });
        } else {
          await addDoc(collection(firestore, 'magazines'), {
            name: magazineName,
            imageUrl,
            pdfUrl,
          });
        }

        // Reset input fields
        setMagazineName('');
        setImageFile(null);
        setPdfFile(null);
        setSelectedMagazineId(null);
        setExistingImageUrl('');
        setExistingPdfUrl('');
      } catch (error) {
        console.error('Error adding magazine:', error);
      }
    }
  };

  const handleEditMagazine = (magazine) => {
    setSelectedMagazineId(magazine.id);
    setMagazineName(magazine.name);
    setExistingImageUrl(magazine.imageUrl);
    setExistingPdfUrl(magazine.pdfUrl);
    setImageFile(null);
    setPdfFile(null);
  };

  const handleDeleteMagazine = async (magazineId, imageUrl, pdfUrl) => {
    try {
      const magazineDoc = doc(firestore, 'magazines', magazineId);
      await deleteDoc(magazineDoc);

      // Delete image and PDF from storage
      const imageRef = ref(storage, `magazines/images/${imageUrl.split('/').pop().split('?')[0]}`);
      await deleteObject(imageRef);

      const pdfRef = ref(storage, `magazines/pdfs/${pdfUrl.split('/').pop().split('?')[0]}`);
      await deleteObject(pdfRef);

      setMagazines(magazines.filter(magazine => magazine.id !== magazineId));
    } catch (error) {
      console.error('Error deleting magazine:', error);
    }
  };

  return (
    <div>
      <h2>{selectedMagazineId ? 'Update Magazine' : 'Add a New Magazine'}</h2>
      <input
        type="text"
        placeholder="Magazine Name"
        value={magazineName}
        onChange={(e) => setMagazineName(e.target.value)}
      />
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files[0])}
      />
      <input
        type="file"
        accept="application/pdf"
        onChange={(e) => setPdfFile(e.target.files[0])}
      />
      <button onClick={handleAddOrUpdateMagazine}>
        {selectedMagazineId ? 'Update Magazine' : 'Add Magazine'}
      </button>

      <h3>Existing Magazines</h3>
      <ul>
        {magazines.map(magazine => (
          <li key={magazine.id}>
            <strong>{magazine.name}</strong>
            <button onClick={() => handleEditMagazine(magazine)}>Edit</button>
            <button onClick={() => handleDeleteMagazine(magazine.id, magazine.imageUrl, magazine.pdfUrl)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MagazineInput;
